import React from 'react';
import { PiggyBank, Wallet, TrendingUp, BarChart } from 'lucide-react';

/**
 * Компонент с параметрами накоплений
 */
const SavingsParametersSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  return (
    <div className="mb-6 bg-green-50 dark:bg-green-900/20 p-4 rounded-lg border border-green-200 dark:border-green-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <PiggyBank className="w-5 h-5 mr-2 text-green-500" />
        Параметры накоплений
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Текущие накопления */}
        <div>
          <label htmlFor="currentSavings" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Wallet className="w-4 h-4 mr-2 text-green-500" />
            Текущие накопления (руб.)
          </label>
          <input
            type="text"
            id="currentSavings"
            name="currentSavings"
            value={formData.currentSavings}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.currentSavings ? 'input-error' : ''}`}
            placeholder="Например, 100 000"
          />
          {errors.currentSavings && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.currentSavings}
            </p>
          )}
        </div>

        {/* Ежемесячный взнос */}
        <div>
          <label htmlFor="monthlyContribution" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <TrendingUp className="w-4 h-4 mr-2 text-green-500" />
            Ежемесячный взнос (руб.)
          </label>
          <input
            type="text"
            id="monthlyContribution"
            name="monthlyContribution"
            value={formData.monthlyContribution}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.monthlyContribution ? 'input-error' : ''}`}
            placeholder="Например, 5 000"
          />
          {errors.monthlyContribution && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.monthlyContribution}
            </p>
          )}
        </div>

        {/* Ожидаемая доходность */}
        <div>
          <label htmlFor="expectedReturn" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <BarChart className="w-4 h-4 mr-2 text-green-500" />
            Ожидаемая доходность (% годовых)
          </label>
          <input
            type="text"
            id="expectedReturn"
            name="expectedReturn"
            value={formData.expectedReturn}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.expectedReturn ? 'input-error' : ''}`}
            placeholder="Например, 5"
          />
          {errors.expectedReturn && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.expectedReturn}
            </p>
          )}
          <p className="mt-1 text-xs text-gray-600 dark:text-gray-400">
            Средняя доходность по банковским вкладам: 6-8%, по консервативному инвестиционному портфелю: 9-12%
          </p>
        </div>

        {/* Ожидаемая инфляция */}
        <div>
          <label htmlFor="inflationRate" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Ожидаемая инфляция (% годовых)
          </label>
          <input
            type="text"
            id="inflationRate"
            name="inflationRate"
            value={formData.inflationRate}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.inflationRate ? 'input-error' : ''}`}
            placeholder="Например, 4"
          />
          {errors.inflationRate && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.inflationRate}
            </p>
          )}
          <p className="mt-1 text-xs text-gray-600 dark:text-gray-400">
            Средняя инфляция в России за последние 5 лет: 4-5%
          </p>
        </div>
      </div>
      
      <div className="mt-4 bg-green-100 dark:bg-green-900/30 p-3 rounded-lg border border-green-200 dark:border-green-800">
        <div className="flex items-start">
          <PiggyBank className="w-5 h-5 text-green-600 dark:text-green-400 mr-3 mt-1" />
          <div>
            <h4 className="text-sm font-medium text-green-700 dark:text-green-300 mb-1">
              Важно о накоплениях
            </h4>
            <p className="text-xs text-green-600 dark:text-green-400">
              Чем раньше вы начнете откладывать, тем больший эффект окажет сложный процент. 
              Регулярные накопления даже небольшими суммами со временем могут значительно 
              вырасти благодаря инвестиционному доходу.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SavingsParametersSection;